import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { TagsList } from '../News/NewsPrimary';
import ButtonArrowed from '../widgets/Buttons/ButtonArrowed';

import './similar-tags.scss';

const contentDict = {
  '/analyze/actually/': {
    label: 'Публикации'
  },
  '/we/news/': {
    label: 'Все новости'
  }
};

class SimilarTags extends PureComponent {
  render() {
    const content = contentDict[this.props.pathname];

    return (
      <div className="similar-tags">
        <div className="container">
          <h4>Найти похожее по&nbsp;тегам:</h4>

          <TagsList
            canNavigate={true}
            tags={this.props.tags}
            pathname={this.props.pathname}
          />

          <ButtonArrowed
            className="news-post-back-link"
            direction="left"
            link={this.props.pathname}
          >
            {content.label} <i>вернуться</i>
          </ButtonArrowed>
        </div>
      </div>
    );
  }
}

SimilarTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object),
  pathname: PropTypes.string.isRequired
};

export default SimilarTags;



// WEBPACK FOOTER //
// ./src/components/NewsPost/SimilarTags.js